<template>
  <el-row id="cardView">
    <el-dialog :title="detailTitle"
               :visible.sync="cardEditOrDetailVisible"
               width="55%"
               top="7vh"
               v-dialogDrag>
      <el-tabs v-model="editOrDetail"
               type="card">
        <el-tab-pane label="基本信息"
                     name="cardBaseInfo"
                     style="padding-left: 40px">
          <el-form :model="curRowInfo"
                   class="curRowInfo">
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>客户名称::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                           @change="changeRowCust"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">卡号::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCardNo"
                          :disabled="!curRowInfo.isEdit"
                          placeholder="若不填写该值，系统随机生成"
                          class="myCardInput"
                          style="width: 100%"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>用户姓名::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCustName"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>月卡分组::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fGroupID"
                           filterable
                              @change="changeRowGroup"
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in groupList"
                             :key="item.fGroupID"
                             :label="item.fGroupName"
                             :value="item.fGroupID">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">证件号码::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCustCreNo"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">用户电话::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fCustPhone"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">用户单位::</el-col>
              <el-col :span="16">
                <el-input v-model="curRowInfo.fCustInfo"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>绑定车牌::</el-col>
              <el-col :span="16">
                <el-input v-model="curRowInfo.fPlateList"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"
                          @blur="plateBlur"></el-input>
              </el-col>
            </el-row>
            <el-row style="margin:0px;">
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="16">
                <div style="color:red;padding-top: 2px">请输入如果有多个车牌，车牌与车牌之间请用空格分隔</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">停放位置::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fStopPlace"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">房间号::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fRoomNo"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>月卡类型::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCardTypeID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in cardTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">车辆类型::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCarTypeID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in carTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>起始时间::</el-col>
              <el-col :span="6">
                <el-date-picker v-model="curRowInfo.fStartTime"
                                :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                                :clearable="false"
                                type="date"
                                placeholder="选择起始时间"
                                style="width:100%"
                                class="cardDateTime">
                </el-date-picker>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass"><span class="isRed">*</span>结束时间::</el-col>
              <el-col :span="6">
                <el-date-picker v-model="curRowInfo.fEndTime"
                                :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                                :clearable="false"
                                type="date"
                                placeholder="选择结束时间"
                                style="width:100%"
                                class="cardDateTime">
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">普通日费率::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fCommRateID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in cardCommList"
                             :key="item.fRateID"
                             :label="item.fRateName"
                             :value="item.fRateID">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">节假日费率::</el-col>
              <el-col :span="6">
                <el-select v-model="curRowInfo.fHoliRateID"
                           filterable
                           :disabled="!curRowInfo.isEdit"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in cardHoliList"
                             :key="item.fRateID"
                             :label="item.fRateName"
                             :value="item.fRateID">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">进场语音::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fInVocMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">进场LED::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fInLedMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">出场语音::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fOutVocMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">出场LED::</el-col>
              <el-col :span="6">
                <el-input v-model="curRowInfo.fOutLedMsg"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">备注::</el-col>
              <el-col :span="16">
                <el-input type="textarea"
                          v-model="curRowInfo.fRemark"
                          :disabled="!curRowInfo.isEdit"
                          class="myCardInput"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"
                      class="el-form-item__label myCardLableClass">
              </el-col>
              <el-col :span="16">
                <span style="color:red;">进场语音，出场语音，进场LED，出场LED可使用 @车牌 变量播报当前进场的车牌号码。</span>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="车牌列表"
                     name="cardPlateInfo">
          <el-table :data="cardPlateList"
                    border
                    highlight-current-row
                    style="width: 100%"
                    ref="cardPlateListTable"
                    height="500">
            <el-table-column type="index"
                             width="80"
                             label="序号">
            </el-table-column>
            <el-table-column prop="plateCode"
                             label="车牌号码">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="绑定场库"
                     name="cardParkInfo">
          <el-row>
            <el-table :data="cardBindParkList"
                      border
                      highlight-current-row
                      style="width: 100%"
                      ref="cardBindParkTable"
                      height="450">
              <el-table-column type="index"
                               width="80"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               label="绑定停车场">
              </el-table-column>
              <el-table-column prop="fPlaceNums"
                               label="车位数量">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="danger"
                             v-if="curRowInfo.isEdit"
                             @click="deleteBindPark(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row style="margin:5px 0px;">
            <el-col :span="4"
                    class="el-form-item__label myCardLableClass">场库名称::</el-col>
            <el-col :span="6">
              <el-select v-model="selfParkID"
                         filterable
                         :disabled="!curRowInfo.isEdit"
                         class="myCardInput">
                <el-option v-for="item in choiceParks"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4"
                    class="el-form-item__label myCardLableClass">车位数量::</el-col>
            <el-col :span="6">
              <el-input v-model="fPlaceNums"
                        :disabled="!curRowInfo.isEdit"
                        class="myCardInput"></el-input>
            </el-col>
            <el-col :span="4"
                    class="el-form-item__label myCardLableClass">
              <el-button type="primary"
                         :disabled="!curRowInfo.isEdit"
                         icon="el-icon-circle-plus"
                         size="small"
                         @click="bindPark">绑定场库</el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="绑定进出通道"
                     name="cardChnlInfo">
          <el-row style="padding-bottom: 10px;padding-top: 10px">
            <el-col :span="10">
              <el-input placeholder="请输入通道名称"
                        v-model="bindChannelName"
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="bindParkQuery"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="10">
              <el-input placeholder="请输入通道名称"
                        v-model="unbindChannelName"
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="unbindParkQuery"></el-button>
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-table :data="cardBindChannelListUI"
                        border
                        style="width: 100%;height: 371px"
                        height="448"
                        highlight-current-row
                        @current-change="bindChnlChange">
                <el-table-column type="index"
                                 label="序号"
                                 width="50">
                </el-table-column>
                <el-table-column prop="ParkNameWithChnlName"
                                 label="绑定停车场通道">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="4"
                    style="text-align: center;">
              <el-row style="padding-top: 120px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-caret-left"
                             style="width: 100px"
                             :disabled="!curRowInfo.isEdit"
                             @click="leftChnlBtnClick"></el-button>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-caret-right"
                             style="width: 100px"
                             :disabled="!curRowInfo.isEdit"
                             @click="rightChnlBtnClick"></el-button>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-table :data="cardUnBindChannelListUI"
                        border
                        style="width: 100%;height: 371px"
                        height="448"
                        highlight-current-row
                        @current-change="unbindChnlChange">
                <el-table-column type="index"
                                 label="序号"
                                 width="50">
                </el-table-column>
                <el-table-column prop="ParkNameWithChnlName"
                                 label="可选停车场通道">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="通道白名单"
                     name="cardChnlWhiteInfo">
          <el-row style="padding-bottom: 10px;padding-top: 10px">
            <el-col :span="10">
              <el-input placeholder="请输入通道名称"
                        v-model="cardBindWhiteName"
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="bindWhiteQuery"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="10">
              <el-input placeholder="请输入通道名称"
                        v-model="cardUnBindWhiteName"
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="unbindWhiteQuery"></el-button>
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-table :data="cardBindWhiteListUI"
                        border
                        style="width: 100%;height: 371px"
                        height="448"
                        highlight-current-row
                        @current-change="bindWhiteChnlChange">
                <el-table-column type="index"
                                 label="序号"
                                 width="50">
                </el-table-column>
                <el-table-column prop="ParkNameWithChnlName"
                                 label="白名单通道">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="4"
                    style="text-align: center;">
              <el-row style="padding-top: 120px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-caret-left"
                             style="width: 100px"
                             :disabled="!curRowInfo.isEdit"
                             @click="leftWhiteBtnClick"></el-button>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="24">
                  <el-button type="primary"
                             icon="el-icon-caret-right"
                             style="width: 100px"
                             :disabled="!curRowInfo.isEdit"
                             @click="rightWhiteBtnClick"></el-button>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-table :data="cardUnBindWhiteListUI"
                        border
                        style="width: 100%;height: 371px"
                        height="448"
                        highlight-current-row
                        @current-change="unbindWhiteChnlChange">
                <el-table-column type="index"
                                 label="序号"
                                 width="50">
                </el-table-column>
                <el-table-column prop="ParkNameWithChnlName"
                                 label="可选通道">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="续费记录"
                     name="cardFeeList">
          <el-row>
            <el-table :data="feeRecordList"
                      border
                      highlight-current-row
                      style="width: 100%"
                      height="500">
              <el-table-column type="index"
                               width="50"
                               label="序号">
              </el-table-column>
              <el-table-column prop="OpLastTime"
                               width="150"
                               label="续费时间">
              </el-table-column>
              <el-table-column prop="CardTypeName"
                               label="月卡类型">
              </el-table-column>
              <el-table-column prop="BatStartTime"
                               label="起始时间"
                               width="150">
              </el-table-column>
              <el-table-column prop="BatEndTime"
                               label="结束时间"
                               width="150">
              </el-table-column>
              <el-table-column prop="fPayAmount"
                               align="right"
                               label="金额">
              </el-table-column>
              <el-table-column prop="nHours"
                               align="right"
                               label="时间（小时）">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <!-- <el-table-column fixed="right"
                                   align="center"
                                   label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini"
                                 type="danger"
                                 v-if="scope.row.fBigRowID === '-1'"
                                 @click="deleteNewPay(scope.$index, scope.row)">删除</el-button>
                    </template>
                  </el-table-column> -->
            </el-table>
          </el-row>
          <!-- <el-row>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">卡号::</el-col>
                <el-col :span="6">
                  <el-input v-model="curRowInfo.fCardNo"
                            :disabled="disabledFlage"
                            class="myCardInput"
                            style="width: 100%"></el-input>
                </el-col>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">用户姓名::</el-col>
                <el-col :span="6">
                  <el-input v-model="curRowInfo.fCustName"
                            :disabled="disabledFlage"
                            class="myCardInput"
                            style="width: 100%"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">绑定车牌::</el-col>
                <el-col :span="6">
                  <el-input v-model="curRowInfo.fPlateList"
                            :disabled="disabledFlage"
                            class="myCardInput"
                            style="width: 100%"></el-input>
                </el-col>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">月卡类型::</el-col>
                <el-col :span="6">
                  <el-input v-model="curRowInfo.fCardTypeName"
                            :disabled="disabledFlage"
                            class="myCardInput"
                            style="width: 100%"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">金额(元)::</el-col>
                <el-col :span="6">
                  <el-input v-model="cardPay.fPayAmount"
                            :disabled="!curRowInfo.isEdit"
                            class="myCardInput"
                            style="width: 100%"></el-input>
                </el-col>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass"
                        v-if="curRowInfo.fCardTypeID === '40'">购买时间(小时)::</el-col>
                <el-col :span="6"
                        v-if="curRowInfo.fCardTypeID === '40'">
                  <el-input v-model="cardPay.fPaySecs"
                            :disabled="!curRowInfo.isEdit"
                            class="myCardInput"
                            style="width: 100%"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">起始时间::</el-col>
                <el-col :span="6"
                        style="margin-top: 9px">
                  <el-date-picker v-model="cardPay.fBatStartTime"
                                  :disabled="!curRowInfo.isEdit"
                                  type="date"
                                  placeholder="选择起始时间"
                                  class="cardDateTime"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-col>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">结束时间::</el-col>
                <el-col :span="6"
                        style="margin-top: 9px">
                  <el-date-picker v-model="cardPay.fBatEndTime"
                                  :disabled="!curRowInfo.isEdit"
                                  type="date"
                                  placeholder="选择结束时间"
                                  class="cardDateTime"
                                  value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass">备注::</el-col>
                <el-col :span="12">
                  <el-input type="textarea"
                            v-model="cardPay.fRemark"
                            :disabled="!curRowInfo.isEdit"
                            class="myCardInput"></el-input>
                </el-col>
                <el-col :span="4"
                        class="el-form-item__label myCardLableClass"
                        style="padding-top: 5px;padding-right: 40px">
                  <el-button type="warning"
                             :disabled="!curRowInfo.isEdit"
                             icon="el-icon-circle-plus"
                             size="small"
                             @click="cardPayClick">续费</el-button>
                </el-col>
              </el-row> -->
        </el-tab-pane>
        <el-tab-pane label="消费记录"
                     name="cardPayInfo">
          <el-row style="padding:5px 10px">
            <el-col :span="8">
              <label>充值包月车余额::</label>
              <el-input :disabled="true"
              style="width:200px"
                        v-model="curRowInfo.fCardAmountName">
              </el-input>
            </el-col>
            <el-col :span="8">
              <label>充值包月车时间::</label>
              <el-input :disabled="true"
               style="width:200px"
                        v-model="curRowInfo.fCardSecsName">
              </el-input>
            </el-col>
             <el-col :span="8">
              <label>充值包月车次数::</label>
              <el-input :disabled="true"
               style="width:200px"
                        v-model="curRowInfo.fCardCount">
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-table :data="cardPayList"
                        border
                        highlight-current-row
                        style="width: 100%"
                        height="450">
                <el-table-column prop="fOpLastTime"
                                 width="150"
                                 label="支付时间">
                </el-table-column>
                <el-table-column prop="fPayAmountName"
                                 align="right"
                                 label="支付金额">
                </el-table-column>
                <el-table-column prop="fPaySecsName"
                                 align="right"
                                 label="支付时长">
                </el-table-column>
                <el-table-column prop="fPayCount"
                                 align="right"
                                 label="支付次数">
                </el-table-column>
                <el-table-column prop="fRemark"
                                 label="支付备注">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="在场记录"
                     name="carPresentList">
          <el-row>
            <el-col>
              <el-table :data="carPresentList"
                        @row-dblclick="handleInfo"
                        border
                        highlight-current-row
                        style="width: 100%"
                        height="500">
                <el-table-column prop="index"
                                 width="50"
                                 label="序号">
                </el-table-column>
                <el-table-column prop="fInTime"
                                 label="进场时间">
                </el-table-column>
                <el-table-column prop="fPlateCode"
                                 label="车牌号码">
                </el-table-column>
                <el-table-column prop="fPlateColor"
                                 label="车牌颜色">
                </el-table-column>
                <el-table-column prop="fIsCard"
                                 label="是否月车">
                </el-table-column>
                <el-table-column prop="fInChnlName"
                                 label="进场通道">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitForm('form')"
                   :loading="save_loading"
                   v-if="curRowInfo.isEdit">{{save_msg}}</el-button>
        <el-button @click="cardEditOrDetailVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <carInfoView ref="child"
                 reportActiveName="pageData"
                 :type="1"></carInfoView>
  </el-row>
</template>
<script>
import carInfoView from './carInfoView'
import * as card from '../api/card'
import * as park from '../api/park'
export default {
  name: 'cardView',
  components: { carInfoView },
  data () {
    return {
      disabledFlage: true,
      save_loading: false,
      save_msg: '保存',
      rightWhiteChnl: {},
      leftWhiteChnl: {},
      rightChnl: {},
      leftChnl: {},
      choiceParks: [],
      groupList: [],
      cardPayList: [],
      selfParkID: '',
      fPlaceNums: '',
      fCustName: '',
      feeRecordList: [],
      cardUnBindWhiteName: '',
      cardUnBindWhiteList: [],
      cardUnBindWhiteListUI: [],
      cardBindWhiteName: '',
      cardBindWhiteList: [],
      cardBindWhiteListUI: [],
      bindChannelName: '',
      cardBindChannelList: [],
      cardBindChannelListUI: [],
      unbindChannelName: '',
      cardUnBindChannelList: [],
      cardUnBindChannelListUI: [],
      cardBindParkList: [],
      cardTypeListDefaultValue: '',
      cardTypeList: [],
      carTypeListDefaultValue: '',
      carTypeList: [],
      cardHoliList: [],
      cardCommList: [],
      cardPlateList: [],
      carPresentList: [],
      curRowInfo: {
        fCustID: '',
        fCardNo: '',
        fCustName: '',
        fGroupID: '',
        fCustCreNo: '',
        fCustPhone: '',
        fCustInfo: '',
        fPlateList: '',
        fStopPlace: '',
        fRoomNo: '',
        fCardTypeID: '',
        fCarTypeID: '',
        fCardTypeName: '',
        fStartTime: '',
        fEndTime: '',
        fCommRateID: '',
        fHoliRateID: '',
        fInVocMsg: '',
        fInLedMsg: '',
        fOutVocMsg: '',
        fOutLedMsg: '',
        fRemark: '',
        isEdit: false,
        fCardAmount: 0,
        fCardSecs: 0,
        fStatus: 0
      },
      editOrDetail: 'cardBaseInfo',
      detailTitle: '',
      cardEditOrDetailVisible: false
    }
  },
  props: {
    choiceCusts: Array,
    cardActiveName: String
  },
  methods: {
    handleInfo (row, column, event) {
      this.$refs.child.handleInfo(row)
    },
    unbindChnlChange (chnl) {
      this.rightChnl = chnl
    },
    bindChnlChange (chnl) {
      this.leftChnl = chnl
    },
    unbindWhiteChnlChange (chnl) {
      this.rightWhiteChnl = chnl
    },
    bindWhiteChnlChange (chnl) {
      this.leftWhiteChnl = chnl
    },
    leftChnlBtnClick () {
      if (!this.rightChnl || !this.rightChnl.fParkID || !this.rightChnl.fChnlID) {
        return
      }
      this.cardBindChannelList.push(this.rightChnl)
      this.cardBindChannelListUI.push(this.rightChnl)
      this.cardUnBindChannelListUI.splice(this.cardUnBindChannelListUI.indexOf(this.rightChnl), 1)
      this.cardUnBindChannelList.splice(this.cardUnBindChannelList.indexOf(this.rightChnl), 1)
    },
    rightChnlBtnClick () {
      if (!this.leftChnl || !this.leftChnl.fParkID || !this.leftChnl.fChnlID) {
        return
      }
      this.cardUnBindChannelList.push(this.leftChnl)
      this.cardUnBindChannelListUI.push(this.leftChnl)
      this.cardBindChannelListUI.splice(this.cardBindChannelListUI.indexOf(this.leftChnl), 1)
      this.cardBindChannelList.splice(this.cardBindChannelList.indexOf(this.leftChnl), 1)
    },
    leftWhiteBtnClick () {
      if (!this.rightWhiteChnl || !this.rightWhiteChnl.fParkID || !this.rightWhiteChnl.fChnlID) {
        return
      }
      this.cardBindWhiteList.push(this.rightWhiteChnl)
      this.cardBindWhiteListUI.push(this.rightWhiteChnl)
      this.cardUnBindWhiteListUI.splice(this.cardUnBindWhiteListUI.indexOf(this.rightWhiteChnl), 1)
      this.cardUnBindWhiteList.splice(this.cardUnBindWhiteList.indexOf(this.rightWhiteChnl), 1)
    },
    rightWhiteBtnClick () {
      if (!this.leftWhiteChnl || !this.leftWhiteChnl.fParkID || !this.leftWhiteChnl.fChnlID) {
        return
      }
      this.cardUnBindWhiteList.push(this.leftWhiteChnl)
      this.cardUnBindWhiteListUI.push(this.leftWhiteChnl)
      this.cardBindWhiteListUI.splice(this.cardBindWhiteListUI.indexOf(this.leftWhiteChnl), 1)
      this.cardBindWhiteList.splice(this.cardBindWhiteList.indexOf(this.leftWhiteChnl), 1)
    },
    deleteBindPark (index, row) {
      // let index2 = this.cardBindParkList.indexOf(row)
      this.$confirm('请确认是否删除【' + row.fParkName + '】停车场车位数据', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.cardBindParkList.splice(index, 1)
      }).catch(() => { })
    },
    addPark (fPark) {
      var bindPark = this.cardBindParkList.filter(item => {
        if (item.fParkID === fPark.fParkID) { return item }
      })
      if (bindPark && bindPark.length > 0) {
        bindPark[0].fPlaceNums = this.fPlaceNums
      } else {
        let bindParkObject = {}
        bindParkObject.fParkName = fPark.fParkName
        bindParkObject.fParkID = fPark.fParkID
        bindParkObject.fPlaceNums = this.fPlaceNums
        this.cardBindParkList.push(bindParkObject)
      }
    },
    bindPark () {
      if ((this.selfParkID || '').trim().length <= 0) {
        this.$message.error('请选择场库')
        return
      }
      if (this.validationNegative(this.fPlaceNums)) {
        this.$message.error('车位数量请输入数字')
        return
      }
      if (this.selfParkID === '0') {
        for (let i = 1; i < this.choiceParks.length; i++) {
          this.addPark(this.choiceParks[i])
        }
      } else {
        let tmpParks = this.choiceParks.filter(item => {
          if (item.fParkID === this.selfParkID) { return item }
        })
        this.addPark(tmpParks[0])
      }
    },
    validationNegative (number) {
      var reg = /^[0-9]*[1-9][0-9]*$/
      if (!reg.test(number)) {
        return true
      } else {
        return false
      }
    },
    submitForm (formName) {
      if ((this.curRowInfo.fCustID || '').length <= 0) {
        this.$message.error('提示：请选择客户')
        return
      }
      if (this.cardBindParkList.length <= 0) {
        this.$message.error('提示：请到【绑定场库】，选择月卡要绑定的场库')
        return
      }
      let tmpCust = this.choiceCusts.filter(item => {
        if (item.fCustID === this.curRowInfo.fCustID) { return item }
      })
      if (tmpCust.length <= 0) {
        this.$message.error('提示：所选择客户不存在')
        return
      }
      // 时间格式化
      this.curRowInfo.fCustNo = tmpCust[0].fCustNo
      if (this.curRowInfo.fStartTime instanceof Date) {
        this.curRowInfo.fStartTime = this.$dateFormat(this.curRowInfo.fStartTime, 'yyyy-MM-dd')
      }
      if (this.curRowInfo.fEndTime instanceof Date) {
        this.curRowInfo.fEndTime = this.$dateFormat(this.curRowInfo.fEndTime, 'yyyy-MM-dd')
      }
      let param = {}
      param.curRowInfo = this.curRowInfo
      param.curRowInfo.fIsDel = 0
      param.cardBindParkList = this.cardBindParkList
      param.cardBindChannelList = this.cardBindChannelList
      param.cardBindWhiteList = this.cardBindWhiteList
      this.save_loading = true
      this.save_msg = '保存中…'
      card.saveCard(param).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.cardEditOrDetailVisible = false
            this.$parent.initData()
            this.$message.success(data.Msg)
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    bindParkQuery () {
      let tmp = this.bindChannelName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardBindChannelListUI = this.copyArr(this.cardBindChannelList)
        return
      }
      this.cardBindChannelListUI = this.cardBindChannelList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindParkQuery () {
      let tmp = this.unbindChannelName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
        return
      }
      this.cardUnBindChannelListUI = this.cardUnBindChannelList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    bindWhiteQuery () {
      let tmp = this.cardBindWhiteName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardBindWhiteListUI = this.copyArr(this.cardBindWhiteList)
        return
      }
      this.cardBindWhiteListUI = this.cardBindWhiteList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    unbindWhiteQuery () {
      let tmp = this.cardUnBindWhiteName.trim().toLowerCase()
      if (tmp.replace(/(^s*)|(s*$)/g, '').length === 0) {
        this.cardUnBindWhiteListUI = this.copyArr(this.cardUnBindWhiteList)
        return
      }
      this.cardUnBindWhiteListUI = this.cardUnBindWhiteList.filter(r => r.ParkNameWithChnlName.toLowerCase().indexOf(tmp) > -1)
    },
    viewCard (row, isNeedServer) {
      this.editOrDetail = 'cardBaseInfo'
      this.curRowInfo.isEdit = false
      if (row && row !== null && typeof (row) !== 'undefined') {
        if (isNeedServer) {
          card.getBaseCardInfo({ fCustID: row.fCustID, fCardID: row.fCardID }).then(res => {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.setData(data.Data.fCustID, data.Data.fCardID, data.Data.fCardTypeID)
                this.setPark(data.Data.fCustID)
                Object.assign(this.curRowInfo, data.Data)
                this.fCustName = data.Data.custName
                this.detailTitle = '【' + data.Data.custName + '】' + data.Data.fCardNo + ((data.Data.fPlateList || '').trim().length > 0 ? ('-' + data.Data.fPlateList) : '')
              }
            }
          })
        } else {
          this.setData(row.fCustID, row.fCardID, row.fCardTypeID)
          this.setPark(row.fCustID)
          Object.assign(this.curRowInfo, row)
          this.fCustName = row.custName
          this.detailTitle = '【' + row.custName + '】' + row.fCardNo + ((row.fPlateList || '').trim().length > 0 ? ('-' + row.fPlateList) : '')
        }
        this.cardEditOrDetailVisible = true
      }
    },
    setDefault () {
      this.cardBindWhiteList = []
      this.cardUnBindWhiteList = []
      this.cardBindChannelListUI = []
      this.cardBindChannelList = []
      this.cardUnBindChannelList = []
      this.cardBindParkList = []
      this.choiceParks = []
      this.cardPlateList = []
      this.groupList = []
      this.feeRecordList = []
      this.cardPayList = []
      this.carPresentList = []
      this.selfParkID = ''
      this.fPlaceNums = ''
      this.bindChannelName = ''
      this.unbindChannelName = ''
      this.cardBindWhiteName = ''
      this.cardUnBindWhiteName = ''
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      this.curRowInfo.fCardAmount = 0
      this.curRowInfo.fCardSecs = 0
      this.cardCommList = [{ fRateID: '0', fRateName: '无' }]
      this.cardHoliList = [{ fRateID: '0', fRateName: '无' }]
      this.curRowInfo.fCardTypeID = this.cardTypeListDefaultValue
      this.curRowInfo.fCarTypeID = this.carTypeListDefaultValue
      this.curRowInfo.fCommRateID = '0'
      this.curRowInfo.fHoliRateID = '0'
      var today = new Date()
      this.curRowInfo.fStartTime = new Date()
      this.curRowInfo.fEndTime = new Date(today.setMonth(today.getMonth() + 1))
    },
    addSyncCard () {
      this.setDefault()
      if (this.choiceCusts.length === 1) {
        this.curRowInfo.fCustID = this.choiceCusts[0].fCustID
        this.changeRowCust(this.curRowInfo.fCustID)
      }
      this.cardEditOrDetailVisible = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.editOrDetail = 'cardBaseInfo'
      this.detailTitle = '新增月卡'
    },
    editCard (index, row) {
      this.editOrDetail = 'cardBaseInfo'
      this.curRowInfo.isEdit = true
      this.curRowInfo.op = 'edit'
      this.curRowInfo.fIsSyn = this.cardActiveName === 'synCardList'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.setData(row.fCustID, row.fCardID, row.fCardTypeID)
        this.setPark(row.fCustID)
        Object.assign(this.curRowInfo, row)
        this.fCustName = row.custName
        this.detailTitle = '【' + row.custName + '】' + row.fCardNo + '-' + row.fPlateList
        this.cardEditOrDetailVisible = true
      }
    },
    copyArr (arr) { // 深层copy
      let res = []
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i])
      }
      return res
    },
    setData (fCustID, fCardID, fCardTypeID) {
      this.cardBindParkList = []
      this.cardUnBindChannelList = []
      this.cardUnBindChannelListUI = []
      this.cardBindChannelList = []
      this.cardBindChannelListUI = []
      this.cardBindWhiteList = []
      this.cardBindWhiteListUI = []
      this.cardUnBindWhiteList = []
      this.cardUnBindWhiteListUI = []
      this.feeRecordList = []
      this.cardPayList = []
      this.carPresentList = []
      this.cardHoliList = [{ fRateID: '0', fRateName: '无' }]
      this.cardCommList = [{ fRateID: '0', fRateName: '无' }]
      this.curRowInfo.fCommRateID = '0'
      this.curRowInfo.fHoliRateID = '0'
      this.fPlaceNums = ''
      this.bindChannelName = ''
      this.unbindChannelName = ''
      this.cardBindWhiteName = ''
      this.cardUnBindWhiteName = ''
      this.curRowInfo.fGroupID = ''

      this.groupList = []
      let param = {}
      param.fCustID = fCustID
      param.fCardID = fCardID
      param.fIsSyn = this.cardActiveName === 'synCardList'
      card.loadCardOtherList(param).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            (data.Data.cardHoliList || []).forEach(item => {
              this.cardHoliList.push(item)
            });
            (data.Data.cardCommList || []).forEach(item => {
              this.cardCommList.push(item)
            })
            // Object.assign(this.cardHoliList, data.Data.cardHoliList)
            // Object.assign(this.cardCommList, data.Data.cardCommList)
            this.cardBindParkList = Object.assign([], data.Data.cardBindParkList)
            this.cardUnBindChannelList = Object.assign([], data.Data.cardUnBindChannelList)
            this.cardUnBindChannelListUI = this.copyArr(this.cardUnBindChannelList)
            this.cardBindChannelList = Object.assign([], data.Data.cardBindChannelList)
            this.cardBindChannelListUI = this.copyArr(this.cardBindChannelList)
            this.cardBindWhiteList = Object.assign([], data.Data.cardBindWhiteList)
            this.cardBindWhiteListUI = this.copyArr(this.cardBindWhiteList)
            this.cardUnBindWhiteList = Object.assign([], data.Data.cardUnBindWhiteList)
            this.cardUnBindWhiteListUI = this.copyArr(this.cardUnBindWhiteList)
            // this.feeRecordList = data.Data.feeRecordList || []

            this.groupList = data.Data.groups || []
          }
        }
      })
      if (fCustID && fCardID) {
        // 月卡查看的续费记录，应该不包含待同步的 this.cardActiveName === 'synCardList'
        card.getRechargeList({ fCardID: fCardID, fCustID: fCustID, isSyn: false }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.feeRecordList = data.Data
            } else {
              this.$message.error('提示：加载月卡续费列表信息失败')
            }
          }
        })
        card.getCarPresnetList({ fCardID: fCardID, fCustID: fCustID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.carPresentList = data.Data || []
            } else {
              this.$message.error('提示：加载在场数据列表信息失败')
            }
          }
        })
        if (fCardTypeID === '30' || fCardTypeID === '40' || fCardTypeID === '50') { // 预付费月卡—抵扣金额（元） 预付费月卡—抵扣时长（秒） 预付费月卡-抵扣次数（次）
          card.getCardPayList({ fCardID: fCardID, fCustID: fCustID }).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.cardPayList = data.Data || []
              } else {
                this.$message.error('提示：加载月卡消费列表信息失败')
              }
            }
          })
        }
      }
    },
    setPark (val) {
      this.choiceParks = []
      this.selfParkID = ''
      park.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmpParks = []
              Object.assign(tmpParks, data.Data)
              this.choiceParks = tmpParks
              if (this.choiceParks && this.choiceParks.length > 0) {
                this.choiceParks.splice(0, 0, { fParkID: '0', fParkName: '全部' })
                this.selfParkID = this.choiceParks[0].fParkID
              }
            }
          }
        }
      })
    },
    changeRowCust (fCustID) {
      this.setData(fCustID, 0, 0)
      this.setPark(fCustID)
      // if (this.curRowInfo.op === 'add') {
      //   api.getCardNo({ fCustID: fCustID }).then((res) => {
      //     let { status, data } = res
      //     if (status === 200) {
      //       if (data.IsOk) {
      //         this.curRowInfo.fCardNo = data.Data
      //       }
      //     }
      //   })
      // }
    },
    changeRowGroup (fGroupID) {
      if (this.curRowInfo.op === 'add') {
        card.getCarGroupNewDefDays({fCustID: this.curRowInfo.fCustID, fGroupID: fGroupID}).then(res => {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let date = new Date(this.curRowInfo.fStartTime.valueOf())
              date.setDate(date.getDate() + parseInt(data.Data))
              this.curRowInfo.fEndTime = date
            } else {
              let date = new Date(this.curRowInfo.fStartTime.valueOf())
              date.setMonth(date.getMonth() + 1)
              this.curRowInfo.fEndTime = date
            }
          }
        })
      }
    },
    plateBlur () {
      if ((this.curRowInfo.fPlateList || '').trim().length > 0) {
        var plateList = (this.curRowInfo.fPlateList || '').trim().split(' ')
        var strPlateList = ''
        for (var i = 0; i < plateList.length; i++) {
          var plate = plateList[i].replace(/\s*/g, '')
          if (strPlateList.indexOf(plate) < 0) {
            strPlateList += plate + ' '
          }
          this.curRowInfo.fPlateList = strPlateList
        }
      }
    }
  },
  watch: {
    'curRowInfo.fPlateList' (newValue, oldValue) {
      this.cardPlateList = []
      if ((this.curRowInfo.fPlateList || '').trim().length > 0) {
        var plateList = (this.curRowInfo.fPlateList || '').trim().split(' ')
        for (var i = 0; i < plateList.length; i++) {
          let tmpPlate = {}
          tmpPlate.plateCode = plateList[i]
          this.cardPlateList.push(tmpPlate)
        }
      }
      if (this.curRowInfo.op === 'edit') {
        this.detailTitle = '【' + this.fCustName + '】' + this.curRowInfo.fCardNo + ((this.curRowInfo.fPlateList || '').trim().length > 0 ? ('-' + this.curRowInfo.fPlateList) : '')
      }
    },
    'curRowInfo.fCardNo' () {
      if (this.curRowInfo.op === 'edit') {
        this.detailTitle = '【' + this.fCustName + '】' + this.curRowInfo.fCardNo + ((this.curRowInfo.fPlateList || '').trim().length > 0 ? ('-' + this.curRowInfo.fPlateList) : '')
      }
    },
    'curRowInfo.fCardTypeID' () {
      let tmpTypes = this.cardTypeList.filter(item => {
        if (item.value === this.curRowInfo.fCardTypeID) { return item }
      })
      if (tmpTypes && tmpTypes.length > 0) {
        this.curRowInfo.fCardTypeName = tmpTypes[0].text
      }
    }
  },
  created () {

  },
  mounted () {
    card.loadCardTypeList().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.cardTypeListDefaultValue = data.Data.cardTypeListDefaultValue || ''
            this.cardTypeList = data.Data.cardTypeList || []
          }
        }
      }
    })
    card.loadCarTypeList().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.carTypeListDefaultValue = data.Data.carTypeListDefaultValue || ''
            this.carTypeList = data.Data.carTypeList || []
          }
        }
      }
    })
  }
}
</script>
<style>
#cardView .is-disabled .el-input__inner,
#cardView .is-disabled .el-textarea__inner {
  color: #606266;
}
#cardView .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#cardView .el-dialog__title {
  color: white;
}
#cardView .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#cardView .el-dialog__body {
  padding: 5px;
}
#cardView .warning-row {
  color: chocolate;
}
#cardView .error-row {
  color: #fb4545;
}
</style>
<style scoped>
.myCardLableClass .isRed {
  color: #fb4545;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.curRowInfo {
  margin-top: 10px;
}
.curRowInfo .el-row {
  margin-top: 10px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/cardView.vue